import React, {useState, useEffect} from 'react'
import Select from 'react-select';
import { Dialog} from '@headlessui/react'

import { useRecoilState } from 'recoil'
import { addTaskModalState, selectedPrintData} from '../atoms/add_task_modal'

import { supabase } from './SupabaseClient'

type TaskQueueModalProps = {
}
const formatPrinterOptionLabel = ({printer_name}:any) => (
  <div style={{ display: "flex" }}>
    <div>
      {printer_name}
    </div>
  </div>
);

const TaskQueueModal: React.FC<TaskQueueModalProps> = (prpos) => {

  const [modal_open, set_modal_open] = useRecoilState(addTaskModalState)
  const [selected_print_data, set_selected_print_data] = useRecoilState(selectedPrintData)

  const [printer_list, set_printer_list]:any[] = useState<any[]>([])

  const [selected_printer_list, set_selected_printer_list]:any[] = useState<any[]>([])

  useEffect(()=>{
    if(modal_open === true){
      handleGetPrinter()
    }

  },[modal_open])

  const handleGetPrinter = async ()=>{
    const {data, error} = await supabase.from('printer_view').select()
    console.log("GET printer")
    console.log(data)
    set_printer_list(data)
  }

  const hnadleAddTask = async () => {
    console.log("Add Task")
    console.log(selected_printer_list)
    console.log(selected_print_data)
    //タスクの追加
    const {data, error}:any = await supabase
        .from('task')
        .insert({print_data_id:selected_print_data.id})
        .select()
    if (error){
        console.log(error)
        alert(error)
        return;
    }

    console.log(data)
    
    const new_task_candidate_printer = selected_printer_list.map((p:any)=>{
      return ({
        task_id: data[0].id,
        printer_id:p.id
      })
    })

    console.log(new_task_candidate_printer)
    //タスク割り当てprinterを追加
    const {data_task, error_task}:any = await supabase
        .from('task_candidate_printer')
        .insert(new_task_candidate_printer)
        .select()
    
    console.log(error_task)
    console.log(data_task)
    alert("キューに追加しました")

    set_modal_open(false)
  }

  return (
    <Dialog 
      open={modal_open} onClose={() => set_modal_open(false)}
      className="relative z-50"
    >
      {
        selected_print_data &&
        <>
            <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
            <div className="fixed inset-0 flex w-screen items-center justify-center p-4">

              <Dialog.Panel className="w-8/12 rounded-2xl rounded bg-white p-6">
                <Dialog.Title className="text-lg font-medium ">
                  {selected_print_data.name}の対象プリンター選択
                </Dialog.Title>
                <Dialog.Description>
                  キューを追加するプリンターを選択してください
                  <Select
                    isMulti
                    className="basic-multi-select"
                    classNamePrefix="select"
                    defaultValue={null}
                    isClearable={true}
                    name="select-printer"
                    getOptionValue={option => option["id"]}
                    value={selected_printer_list}
                    onChange={(selectedOptions)=>set_selected_printer_list(selectedOptions)}
                    options={printer_list}
                    formatOptionLabel={formatPrinterOptionLabel}
                  />
                </Dialog.Description>
                <div className="flex mt-6">
                <button onClick={hnadleAddTask}
                  className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-full"
                >キューに追加</button>
                <button onClick={() => set_modal_open(false)}
                  className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full ml-auto mr-0"
                >Cancel</button>
                </div>
              </Dialog.Panel>

          </div>
        </>
      }
    </Dialog>
  )

}

export default TaskQueueModal